export default "__VITE_ASSET__B5bPDywq__"